/**
 *
 * 公用接口 - 录屏 1.0
 *
 * 功能点:根据预设点绕点飞行
 * 场景:方案汇报
 *
 */
import Vue from "@/main";

let recorder = null;
let recorderData = [];
let recorderUrl = "";

/**
 * 录屏初始化
 * @param {*} fps 帧率,eg: 10
 * @param {*} vbps 视频每秒比特数,eg: 8500000
 */
export function init(fps, vbps) {
  let viewer = Vue.$GLOBAL.map.viewer;
  if (!recorder) {
    const stream = viewer.canvas.captureStream(fps);
    recorder = new MediaRecorder(stream, {
      mimeType: "video/webm;codecs=vp8",
      videoBitsPerSecond: vbps,
    });
  }
  recorderData = [];
  recorder.ondataavailable = function(event) {
    if (event.data && event.data.size) {
      recorderData.push(event.data);
    }
  };
  recorder.onstop = () => {
    recorderUrl = URL.createObjectURL(
      new Blob(recorderData, { type: "video/webm" })
    );
  };
}
/**
 * 开始录屏
 */
export function start() {
  if (recorder) recorder.start();
}
/**
 * 停止录屏
 */
export function stop() {
  if (recorder) recorder.stop();
}
/**
 * 下载录屏
 */
export function download() {
  if (recorderUrl == "") return;
  let a = document.createElement("a");
  a.href = recorderUrl;
  a.download = "record-canvas.mp4"; //"record-canvas.mp4";
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
}
